module.exports = __webpack_public_path__ + "static/img/ms.50c6d32c.png";